<template>
  <div class="fullscreen-background">
    <div class="login-container">
      <el-row justify="center">
        <img class="logo" src="@/assets/img/logo/color_vertical.png" />
      </el-row>
      <div class="login-form">
        <div style="position: relative; height: 18px;">
          <el-text id="error" type="danger" style="position: absolute; font-size: 12px;"></el-text>
        </div>
        <el-form :model="form" :rules="rules" ref="formRef" label-position="top">
          <el-form-item :label="t('LOGIN.MAILADDRESS')" prop="mail_address">
            <el-input v-model="form.mail_address" :placeholder="t('LOGIN.MAILADDRESS')"></el-input>
          </el-form-item>
          <el-form-item :label="t('LOGIN.PASSWORD')" prop="password">
            <el-input v-model="form.password" :placeholder="t('LOGIN.PASSWORD')" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="form.remember_mail_address" :label="t('LOGIN.SAVE_MAILADDRESS')" prop="remember_mail_address"
              style="margin-left: 4px"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-row justify="center">
              <el-button native-type="submit" type="primary" class="login-form__btn"
                @click.prevent="login(form)">{{
                  t("LOGIN.LOGIN") }}
              </el-button>
            </el-row>
          </el-form-item>
          <el-row justify="center">
            <el-text type="info">
              <router-link :to="{ name: 'send-email' }">{{
                t("LOGIN.FORGOT_PASSWORD")
              }}</router-link>
            </el-text>
          </el-row>
        </el-form>
      </div>
      <el-row justify="center">
        <el-link :underline="false" target="_blank" href="https://shine-soken.jp/"><img
            src="@/assets/img/logo/shine_soken_logo.svg" /></el-link>
      </el-row>
    </div>
  </div>
  <el-footer class="notice-message">
    <el-row justify="center">
      {{ t("COMMON.NOTICE_MESSAGE") }}
    </el-row>
  </el-footer>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { storeToRefs } from "pinia";
import { useSessionStore } from "@/stores/auth/session";
import { useResetPasswordStore } from "@/stores/auth/reset-password";

import { ElMessage } from 'element-plus';
import { isNull } from "lodash";

const { t } = useI18n({});
const sessionStore = useSessionStore();
const { getIsAuthenticated } = storeToRefs(sessionStore);
const resetPasswordStore = useResetPasswordStore();

const router = useRouter();

const isError = ref(false);

const formRef = ref(null);
const form = reactive({
  mail_address: "",
  password: "",
  remember_mail_address: sessionStore.savedMailAddressFlg,
});

const validateMail = (rule, value, callback) => {
  if (value === '' || isNull(value)) {
    callback(new Error(t('COMMON.MESSAGE.REQUIRE', { name: t("LOGIN.MAILADDRESS") })));
  } else {
    callback();
  }
}

const validatePass = (rule, value, callback) => {
  if (value === '' || isNull(value)) {
    callback(new Error(t('COMMON.MESSAGE.REQUIRE', { name: t("LOGIN.PASSWORD") })));
  } else {
    callback();
  }
}

const rules = reactive({
  mail_address: [{ validator: validateMail, trigger: [] }],
  password: [{ validator: validatePass, trigger: [] }]
});

onMounted(() => {
  if (resetPasswordStore.getResult === true) {
    ElMessage({
      type: "success",
      message: resetPasswordStore.getMessage,
    });
    resetPasswordStore.resetResult();
  }
  if (sessionStore.savedMailAddressFlg === true) {
    form.mail_address = sessionStore.savedMailAddress;
  }
});

const login = (form) => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      if (form.remember_mail_address === true) {
        sessionStore.$patch({
          savedMailAddressFlg: true,
          savedMailAddress: form.mail_address,
        });
      } else {
        sessionStore.$patch({
          savedMailAddressFlg: false,
          savedMailAddress: "",
        });
      }
      const payload = {
        mail_address: form.mail_address,
        password: form.password,
      };
      await sessionStore.login(payload).then((data) => {
        if (data.success === false) {
          document.getElementById('error').textContent = data.message;
          isError.value = true;
        } else {
          
          isError.value = false;
        }
      })
      if (getIsAuthenticated.value == true && isError.value == false) {
        router.push({ name: "dashboard" });
      }
    }
  });
};
</script>
<style>
.el-form-item__label::before {
  content: "" !important;
  margin-right: 0 !important;
}
</style>
<style lang="scss" scoped>
.fullscreen-background {
  background-color: #eef1f1;
  width: 100%;
  min-height: 100vh;
  margin: auto;
  display: -webkit-inline-flex;
  display: inline-flex;
  vertical-align: middle;
  flex-direction: row;
}

.login-container {
  width: 100%;
  min-width: 400px;
  max-width: 534px;
  margin: 0 auto;
  padding: 3vh 0;
}

.logo {
  width: 150px;
  height: 170px;
  padding: 0;
  flex-shrink: 0;
}

.login-form {
  box-sizing: border-box;
  height: 553px;
  margin: 40px 0;
  padding: 50px 65px 65px;
  border-radius: 8px;
  background: #fff;

  &__btn {
    width: 327px;
    height: 56px;
    flex-shrink: 0;
    color: #fff;
  }

  &__btn:hover {
    background-color: #52A4D1;
    border: none;
  }

  :deep(.el-form-item) {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 50px;
    }
  }

  :deep(.el-input__wrapper) {
    width: 400px;
    height: 50px;
  }

  :deep(.el-checkbox) {
    --el-checkbox-font-size: 16px;
    --el-checkbox-input-height: 16px;
    --el-checkbox-input-width: 16px;
  }
}

.notice-message {
  font-size: xx-small;
  color: var(--systemColorMain);
  background-color: #eef1f1;
}
</style>
